import React from 'react'
import Text from '../../Text'
import { $red60, $white } from '../../../styles/colors/primitives'
import styles from './styles.module.css'

// "A legend retires" pill for products whose production has ended (catalog flag
// `endOfLife` on the shopItem doc). Deliberately anchored TOP-LEFT: every other
// card tag (FreeShippingTag / PreOrderTag / the out-of-stock pill) is absolutely
// positioned top-right and they already stack on each other, so a fourth
// right-hand tag would sit underneath "Free shipping" on most regions.
function EndOfLifeTag({ show }) {
  return (
    <div
      className={[styles.tag, show ? styles.shown : styles.hidden].join(' ')}
      style={{ background: $red60, color: $white }}
    >
      <Text type="tiny">A legend retires - Final units available</Text>
    </div>
  )
}

export default EndOfLifeTag
